"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendAllTypedWithError = void 0;
const common_1 = require("@project-serum/common");
const web3_js_1 = require("@solana/web3.js");
const txs_1 = require("./txs");
const RETRY_ON_TIMEOUT_DEFAULT = 1;
const PARALLEL_SETUP_DEFAULT = false;
/**
 * Similar to `send`, but for an array of transactions and signers.
 *
 * @params initialActionIdxOffset - the initial offset within the order to start running actions from
 */
const sendAllTypedWithError = (provider, reqs, construction, opts, initialActionOrderOffset) => __awaiter(void 0, void 0, void 0, function* () {
    const { onTxDone, parallelSetup: _pSetup } = opts;
    const parallelSetup = _pSetup !== null && _pSetup !== void 0 ? _pSetup : PARALLEL_SETUP_DEFAULT;
    const blockhash = yield provider.connection.getRecentBlockhash(opts.commitment.preflightCommitment);
    const allTxRequests = (0, txs_1.getAllTxRequests)(reqs);
    let txs = allTxRequests.map((r) => {
        let tx = r.tx.tx;
        let signers = r.tx.signers;
        if (signers === undefined) {
            signers = [];
        }
        tx.feePayer = provider.wallet.publicKey;
        tx.recentBlockhash = blockhash.blockhash;
        signers
            .filter((s) => s !== undefined)
            .forEach((kp) => {
            tx.partialSign(kp);
        });
        return tx;
    });
    const signedTxs = yield provider.wallet.signAllTransactions(txs);
    let totalDone = 0;
    const totalNumbTxs = signedTxs.length;
    const onOneTxDone = () => {
        const txDone = allTxRequests[totalDone];
        let actionNames;
        if (txDone.type === "action calls") {
            const offset = initialActionOrderOffset !== null && initialActionOrderOffset !== void 0 ? initialActionOrderOffset : 0;
            const actionOrder = txDone.reqInnerIdx + offset;
            const actionIdxs = construction.actionOrders[actionOrder];
            actionNames = actionIdxs.map((idx) => construction.actions[idx].actionName);
        }
        totalDone += 1;
        if (onTxDone)
            onTxDone(totalDone, totalNumbTxs, actionNames);
    };
    if (onTxDone)
        onTxDone(0, totalNumbTxs);
    const sigs = [];
    let numbSent = 0;
    for (let i = 0; i < reqs.length; i++) {
        const numbTxInGroup = reqs[i].txs.flat().length;
        const sendFN = parallelSetup &&
            (reqs[i].type === "token" || reqs[i].type === "init result accounts")
            ? sendSignedInParallel
            : sendSignedInSequential;
        const rets = yield sendFN(provider, [reqs[i]], signedTxs.slice(numbSent, numbSent + numbTxInGroup), opts, i, onOneTxDone);
        sigs.push(...rets);
        numbSent += numbTxInGroup;
    }
    return sigs;
});
exports.sendAllTypedWithError = sendAllTypedWithError;
const sendSignedInParallel = (provider, reqs, signedTxs, opts, txGroupOffset, onTxDone) => __awaiter(void 0, void 0, void 0, function* () { return sendSigned(provider, reqs, signedTxs, opts, txGroupOffset, true, onTxDone); });
const sendSignedInSequential = (provider, reqs, signedTxs, opts, txGroupOffset, onTxDone) => __awaiter(void 0, void 0, void 0, function* () { return sendSigned(provider, reqs, signedTxs, opts, txGroupOffset, false, onTxDone); });
const getInstrIndexFromSkipPreflight = (e) => {
    const rx = /"InstructionError":\[([0-9]+),/g;
    const arr = rx.exec(e);
    if (arr && arr.length >= 2)
        return parseInt(arr[1]);
    return undefined;
};
const getInstrIndexFromPreflight = (e) => {
    const rx = /Instruction ([0-9]+)/g;
    const arr = rx.exec(e);
    if (arr && arr.length >= 2)
        return parseInt(arr[1]);
    return undefined;
};
const sendAndConfirmRawTransactionWrapper = (connection, tx, opts) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const customConn = new web3_js_1.Connection(
    //@ts-ignore
    connection._rpcEndpoint, {
        commitment: connection.commitment,
        confirmTransactionInitialTimeout: opts.customTxTimeoutMs,
    });
    try {
        const retryAmount = (_a = opts === null || opts === void 0 ? void 0 : opts.retryTxOnTimeout) !== null && _a !== void 0 ? _a : RETRY_ON_TIMEOUT_DEFAULT;
        for (let i = 0; i < retryAmount; i++) {
            try {
                const txRet = yield (0, web3_js_1.sendAndConfirmRawTransaction)(customConn, tx.serialize(), opts === null || opts === void 0 ? void 0 : opts.commitment);
                // Ensure that enough propagation occurs
                if (opts === null || opts === void 0 ? void 0 : opts.propagationSleepMs)
                    yield (0, common_1.sleep)(opts === null || opts === void 0 ? void 0 : opts.propagationSleepMs);
                return txRet;
            }
            catch (e) {
                if (e.message &&
                    e.message.includes("Transaction was not confirmed in")) {
                    // Check signature ${signature} using the Solana
                    const txSigStr = e.message
                        .split("Check signature ")[1]
                        .split(" using the")[0];
                    console.info("Rechecking the tx sig string of", txSigStr);
                    // First query the chain if
                    try {
                        const txRet = yield connection.getSignatureStatus(txSigStr, {
                            searchTransactionHistory: true,
                        });
                        if (txRet === null || txRet === void 0 ? void 0 : txRet.value) {
                            // TODO: wait here for the right status. See https://github.com/Lev-Stambler/malloc-solana2/issues/72
                            if (((_b = txRet.value) === null || _b === void 0 ? void 0 : _b.err) === null) {
                                return txSigStr;
                            }
                            else {
                                throw { errMsg: txRet.value.err };
                            }
                        }
                    }
                    catch (e) {
                        if (i === retryAmount - 1)
                            throw e;
                        if (e === null || e === void 0 ? void 0 : e.errMsg)
                            throw e.errMsg;
                    }
                    // Exponentially back off if a tx is dropped
                    const sleepMs = Math.floor(1000 * Math.pow(2, i));
                    console.error(e, `Could not confirm transaction in time, retrying round ${i} after sleeping ${sleepMs} ms`);
                    yield (0, common_1.sleep)(sleepMs);
                }
                else {
                    throw e;
                }
            }
        }
    }
    catch (e) {
        console.error(e);
        throw e;
    }
});
const sendSigned = (provider, reqs, signedTxs, opts, txGroupOffset, parallel, onTxDone) => __awaiter(void 0, void 0, void 0, function* () {
    const sigs = [];
    const sigProms = [];
    let k = 0;
    // Go over the outer requests
    for (let reqGroupIdx = 0; reqGroupIdx < reqs.length; reqGroupIdx++) {
        // Go over every tx request within an outer request
        for (let txReqIdx = 0; txReqIdx < reqs[reqGroupIdx].txs.length; txReqIdx++) {
            // If the inner request is an array of requests, loop over
            if (Array.isArray(reqs[reqGroupIdx].txs[txReqIdx]))
                for (let innerTxReqIdx = 0; innerTxReqIdx <
                    reqs[reqGroupIdx].txs[txReqIdx].length; innerTxReqIdx++) {
                    const sendFn = () => __awaiter(void 0, void 0, void 0, function* () {
                        var _c;
                        try {
                            const tx = signedTxs[k];
                            sigs.push(yield sendAndConfirmRawTransactionWrapper(provider.connection, tx, opts));
                            onTxDone();
                        }
                        catch (e) {
                            // Hmmmm... action calls are wrong
                            // try to extract the instruction index
                            let instrIdx = 0; // set to 0 as default
                            if (e && ((_c = opts === null || opts === void 0 ? void 0 : opts.commitment) === null || _c === void 0 ? void 0 : _c.skipPreflight) !== true) {
                                instrIdx = getInstrIndexFromPreflight(e.toString());
                            }
                            else if (e) {
                                instrIdx = getInstrIndexFromSkipPreflight(e.toString());
                            }
                            if (!instrIdx) {
                                console.error("Unknown error instruction, assuming the first instruction", e);
                                instrIdx = 0;
                            }
                            throw {
                                err: e,
                                txGroup: reqGroupIdx + txGroupOffset,
                                txFailed: {
                                    txIdx: txReqIdx,
                                    instrIdx: instrIdx,
                                },
                                txInner: innerTxReqIdx,
                            };
                        }
                        k++;
                    });
                    if (!parallel)
                        yield sendFn();
                    else
                        sigProms.push(sendFn());
                }
            else {
                const sendFn = () => __awaiter(void 0, void 0, void 0, function* () {
                    var _d;
                    try {
                        const tx = signedTxs[k];
                        sigs.push(yield sendAndConfirmRawTransactionWrapper(provider.connection, tx, opts));
                        onTxDone();
                    }
                    catch (e) {
                        let instrIdx = 0; // set to 0 as default
                        if (e && ((_d = opts === null || opts === void 0 ? void 0 : opts.commitment) === null || _d === void 0 ? void 0 : _d.skipPreflight) !== true) {
                            instrIdx = getInstrIndexFromPreflight(e.toString());
                        }
                        else if (e) {
                            instrIdx = getInstrIndexFromSkipPreflight(e.toString());
                        }
                        if (!instrIdx) {
                            console.error("Unknown error instruction, assuming the first instruction", e);
                            instrIdx = 0;
                        }
                        throw {
                            err: e,
                            txGroup: reqGroupIdx + txGroupOffset,
                            txFailed: { txIdx: txReqIdx, instrIdx },
                        };
                    }
                    k++;
                    console.info(`Done with sending and confirming the ${k === 0 ? "1st" : k === 1 ? "2nd" : k === 2 ? "3rd" : `${k + 1}th`} sequential tx`);
                });
                if (!parallel)
                    yield sendFn();
                else
                    sigProms.push(sendFn());
            }
        }
    }
    if (parallel)
        yield Promise.all(sigProms);
    console.info(`Done with sending and confirming the ${sigs.length} ${parallel ? "parallel" : "sequential"} tx`);
    return sigs;
});
